import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LayoutService {
  private readonly mq =
    typeof globalThis !== 'undefined' && typeof globalThis.matchMedia === 'function'
      ? globalThis.matchMedia('(max-width: 768px)')
      : null;

  readonly isMobile = signal<boolean>(this.mq?.matches ?? false);
  readonly mobileDrawerOpen = signal(false);

  constructor() {
    this.mq?.addEventListener('change', (e) => this.isMobile.set(e.matches));
  }

  openDrawer():  void { this.mobileDrawerOpen.set(true); }
  closeDrawer(): void { this.mobileDrawerOpen.set(false); }
}
